export default __webpack_public_path__ + "static/article-travel-dream-vacation-dbebc067fb87bf79bdac0744b4e96a49.webp";